import appErrorWrapper from "../App/AppErrorWrapper";
import TourApp from "./TourApp";

const errorWrappedApp = appErrorWrapper((props) => {
  return <TourApp {...props} />;
});

export default errorWrappedApp;
